import apiClient from '../config/api';
let _publicAppsCache = (typeof window !== 'undefined') 
  ? JSON.parse(sessionStorage.getItem('pm_public_apps_cache') || 'null') 
  : null;

/**
 * Service for fetching MaX App store/hub data.
 * These endpoints are reachable by any authenticated tenant user to browse available modules.
 */
const appStoreService = {
  /** Fetch apps visible to current tenant (no SuperAdmin gate) */
  getPublicApps: async (forceRefresh = false) => {
    if (_publicAppsCache && !forceRefresh) {
      return _publicAppsCache;
    }
    try {
      const response = await apiClient.get('/admin/nav-apps/public');
      _publicAppsCache = response.data;
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('pm_public_apps_cache', JSON.stringify(_publicAppsCache));
      }
      return _publicAppsCache;
    } catch (err) {
      if (_publicAppsCache) return _publicAppsCache;
      throw err;
    }
  },

  /** Get a single app by its code */
  getAppByCode: async (code) => {
    const apps = await appStoreService.getPublicApps();
    return Array.isArray(apps) ? apps.find(a => (a.code || '').toLowerCase() === (code || '').toLowerCase()) : null;
  },
};

export default appStoreService;
